import { useCallback, useState } from 'react';

/**
 * Forces React to update.
 */
export function useForceUpdate() {
  const [, setValue] = useState({});
  return useCallback((...args: any[]) => setValue({ args }), []);
}
